import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { UserOutlined} from '@ant-design/icons';
import { Button, Form, Input, Alert, Row, Col, Select,Card, Dropdown, DatePicker } from "antd";
import { saveAccountAppLicensePurchase,updateAccountAppLicensePurchase, showLoading } from 'redux/actions/accountAppLicense';
import { useHistory } from "react-router-dom";
import { motion } from "framer-motion"
import { API_BASE_DEVELOPER_APP } from 'configs/AppConfig';
import 'font-awesome/css/font-awesome.min.css';
import { useTranslation } from "react-i18next";
import moment from "moment";
import axios from 'redux/sagas/initialize';
import { AUTH_TOKEN } from 'redux/constants/Auth';

const AddAccountAppLicensePurchasePage = (props) => {
	const { saveAccountAppLicensePurchase,updateAccountAppLicensePurchase, loading, redirect, message, showMessage, allowRedirect,
		status,accountAppLicensesPurchase,cancel } = props
	const [form] = Form.useForm();
	let history = useHistory();
	const { t } = useTranslation();
	const [licensePurchasePropertiesList,setLicensePurchasePropertiesList]=useState();
	const [licensePurchaseProperty,setLicensePurchaseProperty] = useState("");
	const { Option } = Select;
	const { param } = props;
	const { appId,appInstanceId } = param;
	const dateFormat = "YYYY-MM-DD HH:mm:ss";
	
	const rules = {
		licenseProperty: [
			{ 
				required: true,
				message:  t("impaqx.adminApp.blanklicenseProperty")
			},
			// {	
			// 	message: t("impaqx.adminApp.20CharPermissionId"),
			// 	max : 30
			// },
			// {
			// 	message:t("impaqx.adminApp.validatePermissionId"),
			// 	pattern: new RegExp(/^[a-zA-Z0-9_]+$/)
			// }
		],
		status: [
			{ 
				required: true,
				message: t("impaqx.adminApp.blankStatus")
			}
		]
	  
	}

    const backgroundStyle = {
        backgroundImage: 'url(/img/others/img-17.jpg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    }

	
	const onAddAccountAppLicensePurchase = () => {
    	form.validateFields().then(values => {
			console.log(accountAppLicensesPurchase);
		if(accountAppLicensesPurchase?.id){
			values['userUpdated']=localStorage.getItem("userId");
			values['id']=accountAppLicensesPurchase.id;
			values['licensePropertyId']=licensePurchaseProperty?.id;
		   values['appInstanceId']=appInstanceId;
		    updateAccountAppLicensePurchase(values);
		}else{
		//	values['appId']=appId;
			values['userUpdated']=localStorage.getItem("userId");
		   values['userCreated']=localStorage.getItem("userId");
		   values['licensePropertyId']=licensePurchaseProperty?.id;
		   values['appInstanceId']=appInstanceId;
		   values["status"] = "ACTIVE";
		   saveAccountAppLicensePurchase(values);
		}

		}).catch(info => {
			console.log('Validate Failed:', info);
		});
	}

	useEffect(()=>{
		axios.get(`${API_BASE_DEVELOPER_APP}/developerApp/licensePurchasePropertyList?appId=${appId}`, {
			headers: {
			  'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
			  'Access-Control-Allow-Origin' : '*',
			  'Accept': 'application/json',
			  'Content-Type': 'application/json',
			  accountId: localStorage.getItem("accountId"),
			  appInstanceId: localStorage.getItem("appInstanceId"),
			  accountUserId: localStorage.getItem("accountUserId")
			}
			}).then(response => {
			if (response?.status===200) {
			   setLicensePurchasePropertiesList(response?.data);
			}
		  });
	},[])

	useEffect(() => {
		if (allowRedirect) {
			history.push(redirect)
		}
		if(accountAppLicensesPurchase?.id)
			form.setFieldsValue({
				qty: accountAppLicensesPurchase.qty,
				price: accountAppLicensesPurchase.price,
				currency: accountAppLicensesPurchase.currency,
				pricePerQty: accountAppLicensesPurchase.pricePerQty,
				licenseEffectiveDate: accountAppLicensesPurchase.licenseEffectiveDate,
				licenseExpiryDate: accountAppLicensesPurchase.licenseExpiryDate,
				purchaseDate: accountAppLicensesPurchase.purchaseDate,
				renewalDate: accountAppLicensesPurchase.renewalDate,
				priceOverrideNote: accountAppLicensesPurchase.priceOverrideNote,
				status: accountAppLicensesPurchase.status
			});
  	}, [accountAppLicensesPurchase]);

	  const onSelectLicensePurchaseProperty = (licensePurchaseProperty) => {
		setLicensePurchaseProperty([...licensePurchaseProperty]);
		form.setFieldsValue({
			licensePurchaseProperty: licensePurchaseProperty[0],
		  });
	  };

	  const title = accountAppLicensesPurchase?.id?t("impaqx.adminApp.editAccountAppLicense"):t("impaqx.adminApp.addNewAccountAppLicense");

	return (
		<>
        <div  style={backgroundStyle}>
			<div className="container d-flex flex-column justify-content-center h-100">
                <Row justify="center">
        <Col xs={20} sm={20} md={20} lg={14}>
            <Card className="mt-4" title={`${title}`} align="center">
                <div className="my-2">
                    <div className="text-center">
                    {/* <img className="img-fluid mb-3" src={`${PATH_VARIABLE}/img/${theme === 'light' ? 'logo.png': 'logo-white.png'}`} alt="" width="200"/> */}
                    </div>
                    <Row justify="center">
                        <Col xs={24} sm={24} md={20} lg={20}>
			<motion.div 
				initial={{ opacity: 0, marginBottom: 0 }} 
				animate={{ 
					opacity: showMessage ? 1 : 0,
					marginBottom: showMessage ? 20 : 0 
				}}> 
				{message && message!=="" ?status===200?<Alert type="success" showIcon message={message}></Alert>:<Alert type="error" showIcon message={message}></Alert>:null}
			</motion.div>
			<Form form={form} layout="vertical" name="register-form" onFinish={onAddAccountAppLicensePurchase}>
				{/* <Row justify="center" gutter={24}>
					<Col xs={24} sm={24} md={12} lg={12} className="gutter-row"> */}
								<Form.Item 
												name="licensePurchasePropertyId" 
												rules={rules.licensePurchasePropertyId}
												label={t("impaqx.adminApp.licensePurchaseProperty")}>
												<Select
													placeholder={t("impaqx.adminApp.selectLicensePurchaseProperty")}
													prefix={<Dropdown className="text-primary" />}
													style={{
													width: "100%",
													height: "40px",
													margin: "15px",
													margin: "0px 0px -3px 0px",
													borderRadius: "7px",
													}}
													options={licensePurchasePropertiesList?.map((item, index) => {
													return {
														value: item.id,
														label: item.licenseProperty
													};
													})}
													values={licensePurchaseProperty}
													onChange={(values) => onSelectLicensePurchaseProperty([values])}
												></Select>											
											</Form.Item>
						<Form.Item 
							name="qty" 
							label={t("impaqx.adminApp.qty")}
							rules={rules.price}
							hasFeedback
						>
							<Input prefix={<UserOutlined className="text-primary" />}/>
						</Form.Item>
					{/* </Col>
					<Col xs={24} sm={24} md={12} lg={12} className="gutter-row"> */}
						<Form.Item 
							name="price" 
							label={t("impaqx.adminApp.price")} 
							rules={rules.currency}
							hasFeedback
						>
							<Input prefix={<UserOutlined className="text-primary" />}/>
						</Form.Item>
					{/* </Col>
				</Row> */}
				{/*<Row justify="center" gutter={24}>
				 <Col xs={24} sm={24} md={12} lg={12} className="gutter-row"> */}
						<Form.Item 
							name="currency" 
							label={t("impaqx.adminApp.currency")} 
							rules={rules.pricePerQty}
							hasFeedback
						>
							<Input prefix={<UserOutlined className="text-primary" />}/>
						   {/* <textarea style={{minWidth:'100%',borderRadius:'10px'}}  prefix={<UserOutlined className="text-primary" />} /> */}
							{/* <Input prefix={<UserOutlined className="text-primary" />}/> */}
						</Form.Item>
					{/* </Col> */}
					{/* <Col xs={24} sm={24} md={12} lg={12} className="gutter-row">*/}
                    <Form.Item 
								name="pricePerQty" 
								label={t("impaqx.adminApp.pricePerQty")} 
							rules={rules.qtyUsedAPIEndPoint}
							hasFeedback
							>
						 <Input prefix={<UserOutlined className="text-primary" />}/>
											</Form.Item>
					<Form.Item 
								name="licenseEffectiveDate" 
								label={t("impaqx.adminApp.licenseEffectiveDate")} 
							rules={rules.qtyUsedAPIEndPoint}
							hasFeedback
							>
						 <DatePicker
                                showTime
                                defaultValue={moment(
                                "2015-06-06 00:00:00",
                                dateFormat
                                )}/>
											</Form.Item>	
					<Form.Item 
								name="licenseExpiryDate" 
								label={t("impaqx.adminApp.licenseExpiryDate")} 
							rules={rules.qtyUsedAPIEndPoint}
							hasFeedback
							>
						 <DatePicker
                                showTime
                                defaultValue={moment(
                                "2015-06-06 00:00:00",
                                dateFormat
                                )}/>
											</Form.Item>						
					 <Form.Item 
								name="purchaseDate" 
								label={t("impaqx.adminApp.purchaseDate")} 
							rules={rules.qtyUsedAPIEndPoint}
							hasFeedback
							>
						 <DatePicker
                                showTime
                                defaultValue={moment(
                                "2015-06-06 00:00:00",
                                dateFormat
                                )}/>
							</Form.Item>						
						<Form.Item 
								name="renewalDate" 
								label={t("impaqx.adminApp.renewalDate")} 
							rules={rules.qtyUsedAPIEndPoint}
							hasFeedback
							>
						 <DatePicker
                                showTime
                                defaultValue={moment(
                                "2015-06-06 00:00:00",
                                dateFormat
                                )}/>
						</Form.Item>						
						<Form.Item 
								name="priceOverrideNote" 
								label={t("impaqx.adminApp.priceOverrideNote")} 
							rules={rules.qtyUsedAPIEndPoint}
							hasFeedback
							>
						 <Input prefix={<UserOutlined className="text-primary" />}/>
											</Form.Item>											
					{accountAppLicensesPurchase?<Form.Item 
							name="status" 
							label={t("impaqx.adminApp.status")} 
							rules={rules.status}
							hasFeedback
						>
						  <Select>
							<Option value="ACTIVE">{t("impaqx.adminApp.active")}</Option>
							<Option value="INACTIVE">{t("impaqx.adminApp.inActive")}</Option>
					     </Select>
						</Form.Item>:null}
				{/*	</Col> 
				</Row>*/}
				<Row justify="center" gutter={24}>
				<Col justify="center"xs={24} sm={24} md={12} lg={5} className="gutter-row">
				<Form.Item>
				<Button type="primary" onClick={cancel}>{t("impaqx.adminApp.cancel")}</Button>
				</Form.Item>
				</Col>
				<Col justify="center" xs={24} sm={24} md={12} lg={5} className="gutter-row">
				<Form.Item>
					<Button type="primary" htmlType="submit" block loading={loading}>
					{/* {id!=null&&id>0?"Update":"Create"} */}
                    {t("impaqx.adminApp.save")}
					</Button>
				</Form.Item>
				</Col>
				</Row>
			</Form>
            </Col>
								</Row>
							</div>
						</Card>
					</Col>
				</Row>
            </div>
            </div>
		</>
	)
}

const mapStateToProps = ({accountAppLicense}) => {
	const { loading, message, showMessage, token, redirect,allowRedirect,status } = accountAppLicense;
  return { loading, message, showMessage, token, redirect,allowRedirect,status }
}

const mapDispatchToProps = {
    saveAccountAppLicensePurchase,
	updateAccountAppLicensePurchase,
	showLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAccountAppLicensePurchasePage)
